import { Contract } from '@qover-private/protos-web/qover/dojo/contracts/v1/contract';
import { EntityType } from '@qover-private/protos-web/qover/dojo/contracts/v1/policyholder';
import { Contract as DraftProtos } from '@qover-private/protos-web/qover/dojo/travel/v1/contract';
import { DraftFactory } from '@qover/domain';
import { Draft } from '../Draft';
import * as RiskFactory from './RiskFactory';

export function createFromApiResponse(response?: DraftProtos): Draft {
  const draft = DraftFactory.createFromApiResponse(({
    ...response,
    risk: undefined,
    terms: undefined,
  } as unknown) as Contract);

  const policyholder = draft.policyholder;
  const risk = RiskFactory.mapFromApiResponse(response?.risk, policyholder);

  if (
    policyholder?.entityType === EntityType.ENTITY_TYPE_PERSON &&
    !policyholder?.birthdate
  ) {
    policyholder.firstName = risk.adultsList?.[0]?.firstName;
    policyholder.lastName = risk.adultsList?.[0]?.lastName;
    policyholder.title = risk.adultsList?.[0]?.title;
    if (policyholder.entityType === EntityType.ENTITY_TYPE_PERSON) {
      policyholder.birthdate = risk.adultsList?.[0]?.birthdate;
    }
  }

  return new Draft({
    ...draft,
    policyholder,
    risk,
    terms: response?.terms,
  });
}
